import { createAction, props } from '@ngrx/store';
import { IDataAction } from '../../utils/interfaces/common.interfaces';
import { IAuthParams, IAuthData, IImpersonateParams } from '../../utils/interfaces/auth.interfaces';

export enum AuthActionsTypes {
  LOGIN_AUTH_INFO = '[AUTH] LOGIN_AUTH_INFO',
  LOGIN_AUTH_INFO_SUCCESS = '[AUTH] LOGIN_AUTH_INFO_SUCCESS',
  LOGIN_AUTH_INFO_FAILED = '[AUTH] LOGIN_FAILOGIN_AUTH_INFO_FAILEDLED',

  LOGIN_OPENID = '[AUTH] LOGIN_OPENID',
  LOGIN_LOGIN_OPENID_SUCCESS = '[AUTH] LOGIN_LOGIN_OPENID_SUCCESS',
  LOGIN_LOGIN_OPENID_FAILED = '[AUTH] LOGIN_LOGIN_OPENID_FAILED',

  INVALID_TOKENS = '[AUTH] INVALID_TOKENS',

  TOKEN_REFRESH_FAILED = '[AUTH] TOKEN_REFRESH_FAILED',
}

export const loginAuthInfoAction = createAction(AuthActionsTypes.LOGIN_AUTH_INFO);
export const loginAuthInfoSuccessAction = createAction(AuthActionsTypes.LOGIN_AUTH_INFO_SUCCESS, props<IDataAction<IAuthData>>());
export const loginAuthInfoFailedAction = createAction(AuthActionsTypes.LOGIN_AUTH_INFO_FAILED);

export const loginOpenIdAction = createAction(AuthActionsTypes.LOGIN_OPENID, props<IAuthParams>());
export const loginOpenIdSuccessAction = createAction(AuthActionsTypes.LOGIN_LOGIN_OPENID_SUCCESS);
export const loginOpenIdFailedAction = createAction(AuthActionsTypes.LOGIN_LOGIN_OPENID_FAILED);

export const invalidTokensAction = createAction(AuthActionsTypes.INVALID_TOKENS);

export const tokenRefreshFailedAction = createAction(AuthActionsTypes.TOKEN_REFRESH_FAILED);